import { Injectable } from '@angular/core';
import { IFirstLogin, IUser } from 'app/core';
import { DeviceDetectorService } from 'ngx-device-detector';

export enum Caller {
    FIRST_LOGIN,
    EDIT_INFO
}

@Injectable({
    providedIn: 'root'
})
export class DataSharingService {
    private _firstLoginData: IFirstLogin = null;
    private _editInfoData: IUser = null;
    private _previousCaller: Caller = null;

    constructor(private deviceService: DeviceDetectorService) {}

    addFirstLoginData(data: IFirstLogin) {
        this._firstLoginData = data;
        this._previousCaller = Caller.FIRST_LOGIN;
    }

    addEditInfoData(data: IUser) {
        this._editInfoData = data;
        this._previousCaller = Caller.EDIT_INFO;
    }

    fetchFirstLoginData(): IFirstLogin {
        return this._firstLoginData;
    }

    fetchEditInfoData(): IUser {
        return this._editInfoData;
    }

    isMobile(): boolean {
        return this.deviceService.isMobile();
    }

    isTablet(): boolean {
        return this.deviceService.isTablet();
    }

    isDesktop(): boolean {
        return this.deviceService.isDesktop();
    }
}
